import LogoE from "@assets/images/Group.png";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import EorderingImg from "@assets/images/SiteName.png";
import { Button } from "@material-ui/core";
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined
} from "@material-ui/icons";
import HeadColored from "@saleor/components/HeadColored";
import useAppState from "@saleor/hooks/useAppState";
import useNavigator from "@saleor/hooks/useNavigator";
import { BaseSidebarProps } from "@saleor/macaw-ui/dist/types/Sidebar/types";
import React, { useEffect, useState } from "react";

import MenuItems from "./MenuItems";
import useStyles from "./styles";

interface SidebarProps extends BaseSidebarProps {
  activeId: string;
  onLogout?: () => void;
}
export const menuWidth = 262;
export const shrunkMenuWidth = 104;
const Sidebar: React.FC<SidebarProps> = ({ activeId, menuItems }) => {
  const [{ fullScreen }, dispatchAppState] = useAppState();
  const [expanded, setExpanded] = useState<boolean>(false);
  const [clicked, setCliked] = useState<string>("");
  const sidebarWidth = expanded ? menuWidth : shrunkMenuWidth;
  const classes = useStyles({ expanded, sidebarWidth, fullScreen });
  const navigate = useNavigator();

  const handleClickItem = (id: string) => {
    setCliked(id);
  };

  useEffect(() => {
    dispatchAppState({
      payload: {
        value: expanded
      },
      type: "setExpandMenu"
    });
  }, [expanded]);

  const handleClickToHomePage = () => {
    navigate("/", { resetScroll: true });
  };

  return (
    <div className={classes.root} data-testid="sidebar">
      <Button
        className={classes.floatButton}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? (
          <ArrowBackIosOutlined className={classes.svgIcon} />
        ) : (
          <ArrowForwardIosOutlined className={classes.svgIcon} />
        )}
      </Button>
      <div className={classes.float}>
        <HeadColored />
        <Button
          className={classes.logosContainer}
          onClick={handleClickToHomePage}
        >
          <img src={SCGP_Color} alt={""} className={classes.logoScgp} />
          <span className={classes.logoPipe}></span>
          <div className={classes.logoRightBox}>
            <img src={LogoE} alt={""} className={classes.logoE} />
            <img src={EorderingImg} alt={""} className={classes.logoOrdering} />
          </div>
        </Button>
        <div className={classes.menuContainer}>
          {menuItems.map(menuItem => (
            <MenuItems
              menuItem={menuItem}
              key={menuItem.id}
              onClick={handleClickItem}
              expanded={expanded}
              selected={
                activeId === menuItem.id ||
                (menuItem.children &&
                  menuItem.children.length &&
                  clicked === menuItem.id)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
